import { render, staticRenderFns } from "./AddNewTable.vue?vue&type=template&id=23f25a4c&scoped=true"
import script from "./AddNewTable.vue?vue&type=script&lang=js"
export * from "./AddNewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f25a4c",
  null
  
)

export default component.exports